export default {
    state: {
        backgroundSong: new Audio('/static/songs/bgMusic.mp3'),
        clickSong: new Audio('/static/songs/mouseClick.mp3'),
        yesSong: new Audio('/static/songs/yes.wav'),
        finishSong: new Audio('/static/songs/win.wav'),
        weightScale: new Audio('/static/songs/weightScale.mp3'),
        heightScale: new Audio('/static/songs/heightScale.wav'),
        SoundOn: false,
        soundValue: 50,
        effectValue: 60,
        tutorial: true,

        characters: {
            one: {
                roundOne: 0,
                roundTwo: 0,
                roundThree: 0,
            },
            two: {
                roundOne: 0,
                roundTwo: 0,
                roundThree: 0,
            },
            three: {
                roundOne: 0,
                roundTwo: 0,
                roundThree: 0,
            },
        }
    },
    mutations: {
        toggleTutorial(state: any)
        {
            state.tutorial = !state.tutorial;
        },
        setCharacters(state: any, value: any)
        {
            for (const character in state.characters)
            {
                for (const round in state.characters[character])
                {
                    state.characters[character][round] = value[character][round]['receivedPoints'];
                }
            }
        },

        updateScore(state: any, value: any)
        {
            state.characters[value.character][value.round] += value.score;
        },

        resetScore(state: any)
        {
            for (const character in state.characters)
            {
                for (const round in state.characters[character])
                {
                    state.characters[character][round] = 0;
                    state.characters[character][round] = 0;
                    state.characters[character][round] = 0;
                }
            }
            state.tutorial = true;
        },
        setVolume(state: any, value: number)
        {
            state.soundValue = value*100;
            state.backgroundSong.volume = value;
        },
        toggleSound(state: any)
        {
            if (state.SoundOn)
            {
                state.backgroundSong.pause();
                state.SoundOn = false;
                state.clickSong.volume = 0;
                state.yesSong.volume = 0;
                state.finishSong.volume = 0;
                state.weightScale.volume = 0;
                state.heightScale.volume = 0;
            }
            else
            {
                state.backgroundSong.loop = true;
                state.backgroundSong.play();
                state.SoundOn = true;
                state.clickSong.volume = state.effectValue/100;
                state.yesSong.volume = state.effectValue/100;
                state.finishSong.volume = state.effectValue/100;
                state.weightScale.volume = state.effectValue/100;
                state.heightScale.volume = state.effectValue/100;
            }
        },
        startSound(state: any)
        {
            state.backgroundSong.loop = true;
            state.backgroundSong.play();
            state.SoundOn = true;
        },
        disableEffect(state: any)
        {
            if (!state.SoundOn)
            {
                state.clickSong.volume = 0;
                state.yesSong.volume = 0;
                state.finishSong.volume = 0;
                state.weightScale.volume = 0;
                state.heightScale.volume = 0;
            }
            else
            {
                state.clickSong.volume = state.effectValue/100;
                state.yesSong.volume = state.effectValue/100;
                state.finishSong.volume = state.effectValue/100;
                state.weightScale.volume = state.effectValue/100;
                state.heightScale.volume = state.effectValue/100;
            }
        },
        async setBgMusic(state: any, src: string)
        {
            console.log(src);
            console.log(state.backgroundSong.getAttribute('src'));
            if (src !== state.backgroundSong.getAttribute('src'))
            {
                await state.backgroundSong.pause();
                state.backgroundSong = new Audio(src);
                if (state.SoundOn)
                {
                    state.backgroundSong.loop = true;
                    state.backgroundSong.play();
                    state.backgroundSong.volume = state.soundValue / 100;
                }
            }
        }
    }
};
